"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AudioSource_1 = __importDefault(require("../../classes/AudioSource"));
const getDefinables_1 = __importDefault(require("./getDefinables"));
const getAudioSources = () => {
    const audioSources = new Map;
    (0, getDefinables_1.default)("AudioSource").forEach((audioSource) => {
        const slug = audioSource.slug;
        if (audioSource instanceof AudioSource_1.default) {
            audioSources.set(slug, audioSource);
        }
    });
    return audioSources;
};
exports.default = getAudioSources;
